import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import * as Styled from './GenAIReviewsSummary.styles'

const GenAIReviewsSummary = ({ summary }) => {
  const header = 'Customers Say'
  const disclaimer = 'An AI generated summary based on recent customer reviews'

  if (!summary) {
    return null
  }

  return (
    <Styled.Container data-test='ai-reviews-summary'>
      <Styled.Header>{header}</Styled.Header>
      <p>{summary}</p>
      <Styled.Disclaimer>{disclaimer}</Styled.Disclaimer>
    </Styled.Container>
  )
}

GenAIReviewsSummary.propTypes = {
  summary: PropTypes.string
}

const mapStateToProps = state => {
  const summaryReview = state.bazaarVoiceReview?.reviewsSummary
  return {
    summary: summaryReview
  }
}

export default connect(mapStateToProps)(GenAIReviewsSummary)
